import { curry } from "ramda";
export const isIdEq = curry((a, b) => a._id === b._id);
export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
